import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatrixParams } from 'src/app/shared/models/iCourrier/matrix';
import { MatrixDTO } from '../interfaces/global/global-matrix.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MatrixService {
  private iCourrierURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  getCheckMatrice(data: MatrixParams): Observable<MatrixDTO> {
    let params = new HttpParams();
    Object.keys(data).forEach((key) => {
      if (data[key] !== null) {
        params = params.set(key, data[key]);
      }
    });
    return this.http.get<MatrixDTO>(`${this.iCourrierURL}/Global/CheckMatrice?${params}`);
  }
}
